import { TableauTokenPayload } from '../types/analytics';
import axiosClient from './axiosClient';

export const analyticsApi = {
  getToken: (tableauTokenPayload: TableauTokenPayload) =>
    axiosClient.post('/tableau-token', tableauTokenPayload).then((r) => r.data),
};
